import { CGame } from "./CGame";

export class SoundMgr {
    private static mMusVol:number = 0.25;
    private static mSndVol:number = 0.25;
    private static mVocVol:number = 0.25;
    private static mMusic:PIXI.sound.Sound = null;

    public static init():void {
        PIXI.sound.sound.volumeAll = SoundMgr.mMusVol;
    }

    public static get musVolume() : number {
        return SoundMgr.mMusVol;
    }
    public static get sndVolume() : number {
        return SoundMgr.mSndVol;
    }
    public static get vocVolume() : number {
        return SoundMgr.mVocVol;
    }

    public static set musVolume(vol:number) {
        SoundMgr.mMusVol = vol;
        if( SoundMgr.mMusic != null ) {
            SoundMgr.mMusic.volume = vol;
        }
        //PIXI.sound.sound.volumeAll = SoundMgr.mVolume;
    }
    public static set sndVolume(vol:number) {
        SoundMgr.mSndVol = vol;
    }
    public static set vocVolume(vol:number) {
        SoundMgr.mVocVol = vol;
    }

    public static pauseMusic():void {
        if( SoundMgr.mMusic != null ) {
            SoundMgr.mMusic.pause();
        }
    }

    public static resumeMusic():void {
        if( SoundMgr.mMusic != null ) {
            SoundMgr.mMusic.resume();
        }
    }

    public static playMusic(name:string, loop:boolean = true):void {
        if( SoundMgr.mMusic != null ) {
            SoundMgr.mMusic.stop();
            SoundMgr.mMusic.destroy();
            SoundMgr.mMusic = null;
        }
        SoundMgr.mMusic = PIXI.sound.Sound.from({
            url: name,
            autoPlay: true,
            loop: loop,
            volume: SoundMgr.mMusVol,
            complete: function() {
                CGame.DebugLog('Sound finished');
            }
        });
    }

    public static play(id:string, loop:boolean = false, fgSingle:boolean = false):void {
        if( PIXI.sound.sound.find(id) )
            PIXI.sound.sound.play(id, {loop: loop, singleInstance:fgSingle, volume: SoundMgr.mSndVol});
        else
            CGame.DebugLog("Error SoundMgr.play:" + id);
    }

    public static playVoc(id:string, loop:boolean = false, fgSingle:boolean = false):void {
        PIXI.sound.sound.play(id, {loop: loop, singleInstance:fgSingle, volume: SoundMgr.mVocVol});
    }

    public static stop(id:string):void {
        PIXI.sound.sound.stop(id);
    }

    public static stopAll():void {
        PIXI.sound.sound.stopAll();
    }
}